import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025 Stuck On Steven. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
